import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

import useCollection from 'Hooks/useCollection';
import MissionControlSequenceBar from './index';

const MAX_PAST_EVENTS = 5;

function Container({ getCalendarEvents, householdResource, ...rest }) {
  const [loading, setLoading] = useState(true);
  const [pastCalendarEvents, setPastCalendarEvents] = useState([]);
  const [futureCalendarEvents, setFutureCalendarEvents] = useState([]);
  const { collection: projectedMeetings, setCollection: setProjectedMeetings } = useCollection();

  useEffect(() => {
    const getMeetings = async () => {
      try {
        const prevReq = householdResource
          ?.relationship(fr.relationships.previousFiveConfirmedMeetings.name)
          .link('related')
          .get({
            params: {
              tz: moment.tz.guess(),
            },
          });

        const nextReq = householdResource
          ?.relationship(fr.relationships.nextSixConfirmedMeetings.name)
          .link('related')
          .get({
            params: {
              tz: moment.tz.guess(),
            },
          });

        const requests = [prevReq, nextReq];

        const [previousMeetings, nextMeetings, projectedMeetingsResp = null] = await Promise.all(requests);

        setFutureCalendarEvents(nextMeetings?.resources().list() || []);
        const sortedPrevDates = previousMeetings
          ?.resources()
          .list()
          .sort((a, b) => moment
            .utc(a.attr('startTime'))
            .diff(moment.utc(b.attr('startTime'))));
        setPastCalendarEvents(sortedPrevDates || []);
        setProjectedMeetings(projectedMeetingsResp);
      } catch (e) {
        displayErrorMessage(e, 'Could not fetch meetings');
        displayErrorMessage(e, e.errors);
      }

      setLoading(false);
    };

    if (householdResource) {
      getMeetings();
    }
  }, [householdResource]);

  const pastEvents = pastCalendarEvents.slice(Math.max(pastCalendarEvents.length - MAX_PAST_EVENTS, 0));
  const areMeetingsCategorized = pastCalendarEvents
    .every(resource => resource.attr('status') !== 'uncategorized');

  return (
    <MissionControlSequenceBar
      loading={loading}
      pastEvents={pastEvents}
      futureEvents={futureCalendarEvents}
      projectedMeetings={projectedMeetings}
      areMeetingsCategorized={areMeetingsCategorized}
      {...rest}
    />
  );
}

Container.defaultProps = {
  householdResource: null,
};

Container.propTypes = {
  householdResource: PropTypes.object,
};

export default Container;
